var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.terms),function(quoteTerm,index){return _c('div',{key:index},[_vm._v(" "+_vm._s(quoteTerm.term_product)+" - "+_vm._s(_vm._f("currency")(quoteTerm.term_max_advance))+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }